/** What the rest of the site needs to know about this game without loading it. Its name and
 * pitch are translated: `games.drop.*` in src/locales/common.ts. */
export const BRICK_DROP = {
  /** Key for the stored best score and the game's strings. */
  id: "drop",
} as const;
